import React from "react";
import "./Hero.css";
import HeroImg from "../../Gallery/herologo.png"; // <-- change to your hero image

function Hero() {
  return (
    <section className="hero_section">

      <div className="hero_container">

        {/* LEFT CONTENT */}
        <div className="hero_left">
          <h1 className="hero_title">
            Industrial 3D Metal & Plastic Printing<br />for Prototyping to Production
          </h1>

          <p className="hero_subtext">
            Get high-precision 3D printed parts with export-grade materials, tight tolerances, 
            and rapid delivery. From quick-turn prototypes to durable production components, 
            we support your entire product lifecycle with advanced metal & plastic 3D printing capabilities.
          </p>

          {/* CTA Buttons */}
          <div className="hero_buttons">
            <a href="/services/3d-printing" className="hero_btn_secondary">Explore 3D Printing Services</a>
          </div>

          {/* Certification Strip */}
          {/* <div className="hero_certification">
            <a href="/certifications">Certification + Compliance</a>
            <p>ISO 9001:2015 | Export Compliant | Engineering Support | Global Delivery</p>
          </div> */}
        </div>

        {/* RIGHT IMAGE */}
        <div className="hero_right">
          <img src={HeroImg} alt="3D Printed Metal Component" className="hero_image" />
        </div>

      </div>

    </section>
  );
}

export default Hero;
